export const userConstants = {
    USER_REQUEST: 'USER_REQUEST',
    USER_SUCCESS: 'USER_SUCCESS',
    USER_INFO_SUCCESS: 'USER_INFO_SUCCESS',
    USER_FAILURE: 'USER_FAILURE',
    USER_CHANGE_LANGUE: 'USER_CHANGE_LANGUE'
};